<template>
    <div>
        Test Cookie
    </div>
</template>

<script>
    export default {
        mounted() {

            const cookie = document.cookie = 'sosclick' + "=" + ('1' || "") + '' + "; path=/";
            console.log(cookie);
            alert(document.cookie)
        },
    }
</script>

<style lang="scss" scoped>

</style>